import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { can } from "@/lib/permissions";
import { PageHeader, SectionCard, Loading } from "@/components/common/Primitives";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function MfSettings() {
  const { user } = useAuth();
  const admin = can(user?.role, "mobilfunk:admin");
  const { data, isLoading } = useQuery({ queryKey: ["mf-settings"], queryFn: async () => (await api.get("/mobilfunk/settings")).data });
  const [f, setF] = useState(null);
  useEffect(() => { if (data) setF({ tolerance_amount: data.tolerance_amount ?? 0, tolerance_percent: data.tolerance_percent ?? 0, default_channel: data.default_channel ?? "", currency: data.currency ?? "EUR" }); }, [data]);

  if (isLoading || !f) return <Loading />;
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));

  const save = async () => {
    try {
      await api.put("/mobilfunk/settings", {
        tolerance_amount: Number(f.tolerance_amount) || 0,
        tolerance_percent: Number(f.tolerance_percent) || 0,
        default_channel: f.default_channel, currency: f.currency,
      });
      toast.success("Einstellungen gespeichert");
    } catch (err) { toast.error(apiError(err)); }
  };

  return (
    <div data-testid="mf-settings">
      <PageHeader title="Einstellungen" description="Mobilfunk & Provisionen" />
      <SectionCard title="Soll-Ist-Toleranzen" className="max-w-xl">
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-1.5"><Label>Toleranz Betrag (€)</Label><Input type="number" step="0.01" value={f.tolerance_amount} onChange={(e) => set("tolerance_amount", e.target.value)} disabled={!admin} data-testid="settings-tolerance-amount" /></div>
          <div className="space-y-1.5"><Label>Toleranz Prozent (%)</Label><Input type="number" step="0.01" value={f.tolerance_percent} onChange={(e) => set("tolerance_percent", e.target.value)} disabled={!admin} data-testid="settings-tolerance-percent" /></div>
          <div className="space-y-1.5"><Label>Standard-Vertriebskanal</Label><Input value={f.default_channel} onChange={(e) => set("default_channel", e.target.value)} disabled={!admin} placeholder="z. B. shop" /></div>
          <div className="space-y-1.5"><Label>Währung</Label><Input value={f.currency} onChange={(e) => set("currency", e.target.value)} disabled={!admin} /></div>
        </div>
        {admin && <div className="mt-4"><Button onClick={save} className="bg-accent text-accent-foreground hover:bg-accent/90" data-testid="settings-save">Speichern</Button></div>}
      </SectionCard>
    </div>
  );
}
